<template>
    <div class="" v-if="customerData && customerData.customer">
        <div class="row">
            <div class="col-md-3">
                <div class="card panel create-box ">
                    <div class="card-body p-3">
                        <div class="view-customer-hed">
                            <div class="view-customer-icon"><span><img :src="asset('admin/images/building-icon.png')" alt="building-icon" /></span></div>
                            <div class="rght-txt">
                                <span class="active-txt"><span :class="[customerData.customer.status=='1' ?'lt-bl-bg':'lt-rd-bg']">
                                {{customerData.customer.status=='1' ?'Active':'Inactive'}}</span></span>
                                <h5 class="cmpny-text">{{customerData.customer.company_name}}</h5>
                                <p class="address-txt">{{customerData.customer.address}},{{customerData.customer.city}} {{customerData.customer.state}} {{customerData.customer.post_code}} {{customerData.country_data.name}}</p>
                            </div>
                            <div class="clm2">
                                    <button v-if="(getUser!= null && getUser.user_type == 1) || hasRole('Admin') || hasPerm('add-sales-order')" type="button" v-on:click="addSalesOrder" class="btn btn-small btn-primary me-1 ">Add Sales Order</button>

                                <button v-if="(getUser!= null && getUser.user_type == 1) || hasRole('Admin') || hasPerm('add-quotation')" type="button" v-on:click="gotoCreateRFQ" class="btn btn-small btn-primary ">Create RFQ</button>
                                <button type="button" v-on:click="gotoEdit" class="btn btn-small btn-primary ">Edit</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card panel create-box ">
                    <div class="card-body p-3">
                        <div class="d-flex align-items-center mb-2">
                            <div class="flex-grow-1">
                                <h5 class="card-title mb-0">Contact & Link</h5>
                            </div>
                        </div>
                        <div class="left-blk">
                            <ul class="list-groupvend">
                                <li>
                                <i class="ri-links-fill align-middle me-2"></i>
                                <a v-if="customerData.customer.website!=''" :href="'http://' + customerData.customer.website" target="_blank">
                                    {{customerData.customer.website}}</a>
                                <a v-else href="javascript:void(0)">N/A</a>
                                </li>
                                <li>
                                <i class="ri-phone-line align-middle me-2"></i>
                                <span v-if="customerData.customer.phone_number!=''">{{customerData.customer.phone_number}}</span>
                                <span v-else>N/A</span>
                                </li>
                                <li>
                                <i class="ri-mail-open-line align-middle me-2"></i>
                                <span v-if="customerData.customer.email!=''">{{customerData.customer.email}}</span>
                                <span v-else>N/A</span>
                                </li>
                                <li>
                               <i class="ri-cellphone-fill align-middle me-2"></i>

                                <span v-if="customerData.customer.fax!=''">{{customerData.customer.fax}}</span>
                                <span v-else>N/A</span>

                                </li>

                            </ul>

                        </div>
                    </div>
                </div>

                <div class="card panel create-box ">
                    <div class="card-body shippingcontainer">
                        <div class="d-flex titlesec align-items-center mb-2">
                            <div class="flex-grow-1">
                                <h5 class="card-title mb-0">Shipping Address</h5>
                            </div>
                        </div>
                        <template v-for="(shipping, index) in customerData.customer.customer_shipping_address">

                        <div class="left-blk shipaddress">
                            <ul class="list-groupvend">

                                <li v-if="shipping.address2 != null && shipping.address2 != ''">{{shipping.address2}}</li>
                                <li v-if="shipping.address != null && shipping.address != ''">{{shipping.address}}</li>
                                
                                <li v-if="shipping.city != null && shipping.city != ''">{{shipping.city}}</li>
                                <li v-if="shipping.state != null && shipping.state != ''">{{shipping.state}}</li>
                                <li v-if="shipping.post_code != null && shipping.post_code != ''">{{shipping.post_code}}</li>

                            </ul>

                        </div>
                        </template>
                    </div>
                </div>

            </div>
            <div class="col-md-9">
                <div class="card panel create-box-view mb-3">
                    <div class="card-header headnbtn">
                        <div class="d-flex align-items-center justify-content-between"><h5  class="card-title mb-0 flex-grow-1">Contact({{customerData.customer_contact.length}})</h5></div>
                    </div>
                    <div class="card-body p-4">
                        <div class="row">
                            <template v-if="customerData.customer_contact">
                                <template v-for="contact in customerData.customer_contact">
                                    <div :class="[customerData.customer_contact.length == 1 ? 'col-md-4' : 'col-md-6']">
                                        <div class="vendor-blk-item">
                                            <div class="user-img">
                                                <img :src="asset('admin/images/customer_image.png')" alt="client" />
                                            </div>
                                            <div class="msg-block">
                                                <div class="small-heading">{{contact['contact_name']}}</div>
                                                <p><i class="ri-mail-open-line align-middle me-2"></i> {{contact['contact_email']}}</p>
                                                <p><i class="ri-phone-line align-middle me-2"></i>
                                                    <span v-if="contact['mobile_numbers']">
                                                {{contact['mobile_numbers'].join(', ')}}</span>
                                                    <template v-else>
                                                        N/A
                                                    </template>
                                                </p>
                                                <p>
                                                    <i class="ri-cellphone-fill align-middle me-2"></i>
                                                    <template v-if="contact['office_numbers']">
                                                        {{contact['office_numbers'].join(',')}}
                                                    </template>
                                                    <template v-else>
                                                        N/A
                                                    </template>
                                                </p>
                                                <p><span class="view-rght-txt active-txt"><span
                                                    :class="[contact['contact_status']=='1' ?'lt-bl-bg':'lt-rd-bg']">
                                                {{contact['contact_status']=='1' ?'Active':'Inactive'}}</span></span></p>
                                                <p v-if="contact['default_contact']=='1'">Default Contact<span class="view-rght-txt active-txt"><span
                                                    :class="[contact['default_contact']=='1' ?'lt-bl-bg':'lt-rd-bg']">
                                                {{contact['default_contact']=='1' ?'Yes':'No'}}</span></span></p>
                                                <p>Contact Role<span class="view-rght-txt active-txt"><span>
                                                {{contact['contact_role']}}</span></span></p>
                                                <p v-if="contact.contact_types">Contact Types
                                                    <span class="view-rght-txt active-txt">
                                                        <span v-for="(contact_type, contact_type_index) in contact.contact_types"><template v-if="contact_type_index > 0">, </template>{{contact_type.name}}</span>
                                                    </span>
                                                </p>

                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </template>

                            <template v-if="customerData.customer_contact_billing">
                                <template v-for="contact in customerData.customer_contact_billing">
                                    <div :class="[customerData.customer_contact.length == 1 ? 'col-md-4' : 'col-md-6']">
                                        <div class="vendor-blk-item">
                                            <div class="user-img">
                                                <img :src="asset('admin/images/customer_image.png')" alt="client" />
                                            </div>
                                            <div class="msg-block">
                                                <div class="small-heading">{{contact['contact_name']}}</div>
                                                <p><i class="ri-mail-open-line align-middle me-2"></i> {{contact['contact_email']}}</p>
                                                <p><i class="ri-phone-line align-middle me-2"></i>
                                                    <span v-if="contact['mobile_numbers']">
                                                {{contact['mobile_numbers'].join(', ')}}</span>
                                                    <template v-else>
                                                        N/A
                                                    </template>
                                                </p>
                                                <p>
                                                    <i class="ri-cellphone-fill align-middle me-2"></i>
                                                    <template v-if="contact['office_numbers']">
                                                        {{contact['office_numbers'].join(',')}}
                                                    </template>
                                                    <template v-else>
                                                        N/A
                                                    </template>
                                                </p>
                                                <p><span class="view-rght-txt active-txt"><span
                                                    :class="[contact['contact_status']=='1' ?'lt-bl-bg':'lt-rd-bg']">
                                                {{contact['contact_status']=='1' ?'Active':'Inactive'}}</span></span></p>
                                                <p v-if="contact['default_contact']=='1'">Default Contact<span class="view-rght-txt active-txt"><span
                                                    :class="[contact['default_contact']=='1' ?'lt-bl-bg':'lt-rd-bg']">
                                                {{contact['default_contact']=='1' ?'Yes':'No'}}</span></span></p>
                                                <p>Contact Role<span class="view-rght-txt active-txt"><span>
                                                {{contact['contact_role']}}</span></span></p>
                                                <p v-if="contact['contact_type_id'] != '1'">Contact Type
                                                <span class="view-rght-txt active-txt"></span>
                                               <span v-if="contact['contact_type_id'] == 2"> Quotes</span>
                                               <span v-if="contact['contact_type_id'] == 3"> Sales Orders</span>
                                               <span v-if="contact['contact_type_id'] == 4"> Billing</span>
                                               <span v-if="contact['contact_type_id'] == 5"> Packing List</span>
                                               </p>

                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </template>


                        </div>

                        <div>
                            <h5  class="card-title mb-2 mt-3">About Us</h5>
                            <p>{{customerData.customer.about_us}}</p>
                        </div>
                         <div>
                            <h5  class="card-title mb-2 mt-3">SO Note</h5>
                            <p>{{customerData.customer.customer_so_note}}</p>
                        </div>
                        <div>
                            <h5  class="card-title mb-2 mt-3">Payment Terms</h5>
                            <p>{{customerData.customer.customer_payment_terms}}</p>
                        </div>

                        <div>
                            <h5  class="card-title mb-2 mt-3">Stocking Terms</h5>
                            <p>{{customerData.customer.stocking_terms}}</p>
                        </div>

                    </div>

                </div>


                 <div class="row">

        <div class="col-lg-12 col-md-12">
            <div class="card">
                <div class="card-header border-0">
                    <div class="d-flex align-items-center">
                        <h5 class="card-title mb-0 flex-grow-1">Quotation List</h5>
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive product-create table-card">
                        <table class="table table-custom align-middle table-nowrap mb-0">
                            <thead>
                            <tr>
                                <th style="width: 140px">Quote #</th>
                                <th style="width: 120px">Date Added</th>
                                <th>Customer Name</th>
                                <th>Item Name</th>
                                <th>Status</th>


                            </tr>
                            </thead>
                            <template v-if="orderData != null && orderData.data.length > 0">
                                <template v-for="(item, index) in orderData.data">
                                    <tr :id="item.id" :key="item.id" :class="{'mark-as-important': item.priority == 1}">

                                        <td>
                                            <router-link :to="{ name: 'viewQuote', params: { id: item.id }}" class="edit-btn">#{{ item.quotation_number }}</router-link>
                                        </td>
                                        <td :title="item.quote_date">{{ formatDate(item.quote_date) }}</td>
                                        <td><template v-if="item.customer_data">{{item.customer_data.company_name}}</template> <template v-if="item.contact_name!=''"> , ({{item.contact_name}}) </template></td>
                                        <td class="product_text"><span class="prod-wrap">{{item.item_name}}</span></td>

                                        <td>
                                            <span class="lt-bl-bg" :class="getQuotationStatusCssClass(item)" v-if="item.status_details">{{item.status_details.name}}</span>

                                            <span v-if="item.id != item.parent_quote" class="lt-bl-bgs blue">clone</span>

                                        </td>


                                    </tr>
                                </template>
                            </template>

                        </table>

                        <div class="btnrow text-left" v-if="orderData != null && orderData.data.length">
                            <template>
                                <div class="overflow-auto">
                                    <b-pagination
                                        v-model="current_page"
                                        :total-rows="total"
                                        :per-page="per_page"
                                    ></b-pagination>
                                </div>
                            </template>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <!-- Order List  -->
    <div class="mb-1 row">

        <div class="col-lg-12 col-md-12">
            <div class="card">
                <div class="card-header border-0">
                    <div class="d-flex align-items-center">
                        <h5 class="card-title mb-0 flex-grow-1">Orders List</h5>
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive product-create table-card">
                        <table class="table table-custom align-middle table-nowrap mb-0">
                            <thead>
                            <tr>
                                <th style="width: 140px">Order #</th>
                                <th>Planned Delivery Date</th>
                                <th>Customer</th>
                                <th>Amount</th>

                                <th>Created</th>
                                <th>Updated</th>
                                <th></th>
                                <th style="width: 180px;">Status</th>


                            </tr>
                            </thead>
                            <template v-if="soorderData != null && soorderData.data.length > 0">
                                <template v-for="(item, index) in soorderData.data">
                                   <tr :id="item.id" :key="item.id" :class="{'mark-as-important': item.priority == 1}">
                                    <td scope="row">

                                    </td>
                                    <td>
                                        <router-link :to="{ name: 'orderShow', params: { id: item.id }}" class="edit-btn">#{{ item.order_number }}</router-link>
                                    </td>
                                    <td>{{ item.eta }}</td>
                                    <td>
                                        <template v-if="item.customer">
                                            {{item.customer.company_name}}
                                        </template>
                                    </td>
                                    <td>${{ item.total_amount }}</td>

                                    <td>{{ item.created_at_date }}</td>
                                    <td>{{ item.updated_at_date }}</td>
                                    <td><span :class="formatStatusClass(item)">{{ item.order_status ? item.order_status.name : "" }}</span></td>

                                </tr>
                                </template>
                            </template>

                        </table>

                        <div class="btnrow text-left" v-if="soorderData != null && soorderData.data.length">
                            <template>
                                <div class="overflow-auto mb-2">
                                    <b-pagination
                                        v-model="current_page1"
                                        :total-rows="total1"
                                        :per-page="per_page1"
                                    ></b-pagination>
                                </div>
                            </template>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <!-- Order list ends here -->

            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";

export default {
    name: "CustomerDetail",
    props: ['customerData'],
    created() {
        console.log("check dataaaaa ",this.customerData);
        this.getCustomerOrdersSo();
        this.getCustomerOrders();

    },
    data(){
        return {
            orderData:{
                data:[]
            },
            soorderData:{
                data:[]
            },

            current_page:1,
            per_page:10,
            total:0,
            current_page1:1,
            per_page1:10,
            total1:0,
            // customerData: {
            //     customer: {
            //         status:null
            //     },
            //     country_data: null,
            //     customer_contact: null,
            //     can_add_customer: false,
            //     can_edit_customer: false,
            //     can_delete_customer: false,
            //     user_type: null,
            //     role: null
            // }
            newOrder: {
                id: null,
                is_draft: 0,
                is_stocking: 0,
                stocking_terms: null,
                warehouses: [],
                customerWarehouses: [],
                billTo: [],
                customer_id: null,
                sales_rep_id: null,
                order_number: null,
                order_date: null,
                customer_terms: null,
                customer_po: null,
                eta: null,
                fob: null,
                notes: null,
                customer_notes: null,
                quotations: [],
                customer: {
                    quotations_after_sent_to_customer: []
                },
                products:[],
                selectedProducts: [],
            },
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setCustomers',
            'setCustomerLoading',
            'setNewOrder',
            'setNewQuotation'
        ]),
        formatStatusClass(item) {
            if(item.order_status) {
                return item.order_status.name.toLowerCase().replace(/\s+/g, '-').replace("/", "-").toLowerCase();
            }
            return "";
        },
         getQuotationStatusCssClass(item) {
            let cssClass = '';
            if(item.status=='2') {
                cssClass = 'lght-peach';
            } else if(item.status=='3') {
                cssClass ='lght-pink';
            } else if(item.status=='4') {
                cssClass ='lght-green';
            } else if(item.status=='5') {
                cssClass ='lght-grn';
            } else {
                cssClass ='lght-blue';
            }
            return cssClass;
        },
        getCustomerOrdersSo(){

            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('orders.index', {search_customer_id: this.$route.params.id}), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors.length > 0){

                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){

                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.soorderData = data.data.orders;
                        this.current_page1 = data.data.orders.current_page;
                        this.per_page1 = data.data.orders.per_page;
                        this.total1 = data.data.orders.total;
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        getCustomerOrders() {
            let self = this;
            this.setCustomerLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('quotations.customer.ajaxLoad', {cus_id: this.$route.params.id,type:"customer"}), {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({ data }) => {
                    if(data.errors){
                        self.setCommonErrors(data.errors);
                    } else if(data.errorMessage){
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        this.orderData = data.data.quotations;
                        //console.log("purchase order",data);;
                        this.current_page = data.data.quotations.current_page;
                        this.per_page = data.data.quotations.per_page;
                        this.total = data.data.quotations.total;
                        console.log("purchase order",this.orderData);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setCustomerLoading(false);

                });
        },
        getSLNo(index) {
            return Number(this.customerData.config['start_from']) + index;
        },
        addSalesOrder() {
            this.newOrder.customer_id = null;
            this.newOrder.quotations = [];
            if (this.customerData && this.customerData.customer) {
                this.newOrder.customer_id = this.customerData.customer.id;
                this.newOrder.customer = this.customerData.customer;
                this.newOrder.sales_rep_id = this.customerData.customer.sales_rep ? this.customerData.customer.sales_rep.id : null;
            }

            this.setNewOrder(this.newOrder);
            this.$router.push({ name: 'selectCustomer'});
        },
        gotoCreateRFQ() {
            let rfq = {
                parent_quote: null,
                quote_number: null,
                is_draft: null,
                quote_name: null,
                customer: {
                    id: this.customerData.customer.id,
                    sales_rep_id: this.customerData.customer.sales_rep ? this.customerData.customer.sales_rep.id : null,
                    text: this.customerData.customer.company_name,
                    name: this.customerData.customer.company_name,
                    html: this.customerData.customer.company_name,
                },
                customer_id: this.customerData.customer.id,
                sale_rep: this.customerData.customer.sales_rep ? this.customerData.customer.sales_rep.id : null,
                files_attached: [],
                notes: [""],
                products: [
                    {
                        name: null,
                        description: null,
                        quantity_unit: 'bags',
                        is_master_product_modify: false,
                        tiers: [
                            {
                                tier: null,
                                sku: null
                            },
                            {
                                tier: null,
                                sku: null
                            },
                            {
                                tier: null,
                                sku: null
                            }
                        ],
                    }
                ],

            };
            this.setNewQuotation(rfq);
            this.$router.push({ name: 'addQuotePage'});
        },
        gotoEdit(){

             this.$router.push({name: 'editCustomer', params: {id: this.customerData.customer.id} });

        }
    },
    watch: {
        current_page: {
        handler: function(value) {

            if(value != 1){
                this.getCustomerOrders();
            }

            console.log("watch ",value);
            // this.fetchData().catch(error => {
            // console.error(error)
            // })
        }
        },
        current_page1: {
        handler: function(value) {

            if(value != 1){
                this.getCustomerOrdersSo();
            }

            console.log("watch ",value);
            // this.fetchData().catch(error => {
            // console.error(error)
            // })
        }
        }
    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'customers',
            'customersLoading'
        ])
    }
}
</script>

<style scoped>

</style>
